import { api } from '../../lib/apiClient';

export type LLMKey = {
  id: string;
  name: string;
  provider: 'anthropic';
  key_prefix: string;
  created_at: string;
  last_used_at?: string;
};

export async function listLLMKeys(orgId: string): Promise<LLMKey[]> {
  const res = await api.get<{ data: { items: LLMKey[] } }>(`/v1/orgs/${orgId}/llm-keys`);
  return res.data.data?.items ?? [];
}

export async function createLLMKey(
  orgId: string,
  input: { name: string; provider: 'anthropic'; plaintext: string },
): Promise<LLMKey> {
  const res = await api.post<{ data: LLMKey }>(`/v1/orgs/${orgId}/llm-keys`, input);
  return res.data.data;
}

export async function deleteLLMKey(orgId: string, id: string): Promise<void> {
  await api.delete(`/v1/orgs/${orgId}/llm-keys/${id}`);
}
